export const SOCIAL_MEDIA_TYPE = {
  YOUTUBE: 'YOUTUBE',
  INSTAGRAM: 'INSTAGRAM',
  FACEBOOK: 'FACEBOOK',
  TWITTER: 'TWITTER',
  TIKTOK: 'TIKTOK',
  LINKEDIN: 'LINKEDIN',
  TRUSTPILOT: 'TRUSTPILOT',
};

export const SOCIAL_MEDIA_PARAMETER = {
  COMMENTS: 'COMMENTS',
  FOLLOWERS: 'FOLLOWERS',
  POSTS: 'POSTS',
  SHARES: 'SHARES',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FOLLOWING: 'FOLLOWING',
  LIKES: 'INTERACTIONS',
  EMPLOYEES: 'EMPLOYEES',
  SCORE: 'SCORE',
  REVIEWS: 'REVIEWS',
};

export const SOCIAL_TYPE_COLUMNS = {
  [SOCIAL_MEDIA_TYPE.INSTAGRAM]: [
    SOCIAL_MEDIA_PARAMETER.FOLLOWERS,
    SOCIAL_MEDIA_PARAMETER.LIKES,
    SOCIAL_MEDIA_PARAMETER.COMMENTS,
    SOCIAL_MEDIA_PARAMETER.POSTS,
  ],
  [SOCIAL_MEDIA_TYPE.FACEBOOK]: [
    SOCIAL_MEDIA_PARAMETER.FOLLOWERS,
    SOCIAL_MEDIA_PARAMETER.LIKES,
    SOCIAL_MEDIA_PARAMETER.COMMENTS,
    SOCIAL_MEDIA_PARAMETER.POSTS,
  ],
  [SOCIAL_MEDIA_TYPE.TWITTER]: [
    SOCIAL_MEDIA_PARAMETER.FOLLOWERS,
    SOCIAL_MEDIA_PARAMETER.FOLLOWING,
    SOCIAL_MEDIA_PARAMETER.SUBSCRIPTION,
  ],
  [SOCIAL_MEDIA_TYPE.YOUTUBE]: [
    SOCIAL_MEDIA_PARAMETER.POSTS,
    SOCIAL_MEDIA_PARAMETER.LIKES,
    SOCIAL_MEDIA_PARAMETER.COMMENTS,
  ],
  [SOCIAL_MEDIA_TYPE.TIKTOK]: [
    SOCIAL_MEDIA_PARAMETER.FOLLOWERS,
    SOCIAL_MEDIA_PARAMETER.FOLLOWING,
    SOCIAL_MEDIA_PARAMETER.LIKES,
  ],
  [SOCIAL_MEDIA_TYPE.LINKEDIN]: [SOCIAL_MEDIA_PARAMETER.FOLLOWERS, SOCIAL_MEDIA_PARAMETER.EMPLOYEES],
  [SOCIAL_MEDIA_TYPE.TRUSTPILOT]: [SOCIAL_MEDIA_PARAMETER.SCORE, SOCIAL_MEDIA_PARAMETER.REVIEWS],
};

export const SOCIAL_MEDIA_PARAMETER_TO_LOCALS = {
  [SOCIAL_MEDIA_PARAMETER.COMMENTS]: 'comments',
  [SOCIAL_MEDIA_PARAMETER.FOLLOWERS]: 'followers',
  [SOCIAL_MEDIA_PARAMETER.POSTS]: 'posts',
  [SOCIAL_MEDIA_PARAMETER.INTERACTIONS]: 'interactions',
  [SOCIAL_MEDIA_PARAMETER.SHARES]: 'shares',
  [SOCIAL_MEDIA_PARAMETER.SUBSCRIPTION]: 'subscription',
  [SOCIAL_MEDIA_PARAMETER.FOLLOWING]: 'following',
  [SOCIAL_MEDIA_PARAMETER.LIKES]: 'likes',
  [SOCIAL_MEDIA_PARAMETER.EMPLOYEES]: 'employees',
  [SOCIAL_MEDIA_PARAMETER.SCORE]: 'score',
  [SOCIAL_MEDIA_PARAMETER.REVIEWS]: 'reviews',
};
